
import { schema } from "./types";
import { IAutomationAppComponent } from "../../../types";
import { OverviewPanel, OperatorPanel } from './';
import { ParameterPanel } from "./ParameterPanel";
import { IoCubeOutline } from "react-icons/io5";
import InsightsPanel from "../../components/PlantInsights/InsightsPanel";
import InsightsSideviewPanel from "../../components/PlantInsights/InsightsSideviewPanel";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: IoCubeOutline,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ParameterPanel: ParameterPanel,
    InsightsPanel: InsightsPanel,
    SideViewPanel: InsightsSideviewPanel,
    createConfig:      {
        group: "Plants",
        name: "A generic Machine etc.",
        description: "A generic Machine etc.",
        panel: OverviewPanel,
    },
}
 
 